export default "__VITE_ASSET__Dox8yM9f__"